import { session } from 'gipsy-api'
import moment from 'moment'
import qs from 'qs'

const extractStateParameters = location => {
  const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  const nonce =
    window.sessionStorage.getItem('nonceOAuth-google') || window.sessionStorage.getItem('nonceOAuth-microsoft') || ''
  const res = {
    error: searchParams.error,
    state: searchParams.state,
    localStateGoogle: window.sessionStorage.getItem('stateOAuth-google'),
    localStateMicrosoft: window.sessionStorage.getItem('stateOAuth-microsoft'),
    code: searchParams.code,
    nonce,
    tz: moment.tz.guess(),
    invitationId: window.sessionStorage.getItem('invitationId'),
    redirectUri: searchParams.redirectUri || null
  }

  if (res.invitationId) {
    window.sessionStorage.removeItem('invitationId')
  }

  window.sessionStorage.removeItem('stateOAuth-microsoft')
  window.sessionStorage.removeItem('stateOAuth-google')
  window.sessionStorage.removeItem('nonceOAuth-google')
  window.sessionStorage.removeItem('nonceOAuth-microsoft')

  return res
}

export const handleOAuth = async location => {
  const {
    error,
    state,
    localStateGoogle,
    localStateMicrosoft,
    code,
    tz,
    nonce,
    invitationId,
    redirectUri
  } = extractStateParameters(location)

  const querySucceeded = !error && code
  if (!querySucceeded) {
    throw new Error('Query failed.')
  }
  let data
  if (state === localStateGoogle) {
    if (invitationId) {
      data = await session.signup('google', code, nonce, tz, invitationId)
      data.isSignup = true
      data.emailProvider = 'google'
    } else {
      data = await session.authenticate('google', code, nonce, tz, redirectUri)
    }
  } else if (state === localStateMicrosoft) {
    if (invitationId) {
      data = await session.signup('microsoft', code, nonce, tz, invitationId)
      data.isSignup = true
      data.emailProvider = 'microsoft'
    } else {
      data = await session.authenticate('microsoft', code, nonce, tz, redirectUri)
    }
  } else {
    throw new Error('Unknown OAuth method.')
  }
  return data
}



// WEBPACK FOOTER //
// ./src/pages/oauthCallback/utils.js